import Abstract from "../../../abstract-view/abstract.js";

export default class Categories extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._changeHandler = this._changeHandler.bind(this);
  }

  getActiveCategoryId() {
    const activeOption = this._element.selectedOptions[0];
    const activeCategory = (activeOption) ?
      +activeOption.dataset.id :
      null;

    return (activeCategory) ? activeCategory : null;
  }

  setChangeHandler(callback) {
    this._callback.change = callback;
    this._element.addEventListener(`change`, this._changeHandler);
  }

  _changeHandler() {
    this._callback.change(this.getActiveCategoryId());
  }
}
